import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  DOCUMENT,
  Inject,
  OnInit,
} from "@angular/core";
import { Router, RouterOutlet, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { ThemeService } from "./services/theme-service";
import { Settings } from "./utils/settings";
import { IndexedDBService } from "./services/indexeddb.service";
import { cleanupCreditsFromIndexedDB } from "./utils/cleanup-indexeddb-credits";

export const appCon = {
  assetIconsUrl: "assets/icons/heroicons/optimized/24/outline",
};

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: "./app.html",
  styleUrl: "./app.scss",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class App implements OnInit {
  protected title = "daisy-app";
  theme: string | null = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private th: ThemeService,
    private router: Router,
    private indexedDB: IndexedDBService,
  ) {}

  async ngOnInit() {
    // Initialize Settings with IndexedDB
    await Settings.init(this.indexedDB);

    // Clean up any credit data from IndexedDB (credits should never be persisted locally)
    try {
      const cleanupResult = await cleanupCreditsFromIndexedDB(this.indexedDB);
      if (cleanupResult.itemsCleaned.length > 0) {
        console.log(
          "🧹 Cleaned up credit data from IndexedDB:",
          cleanupResult.itemsCleaned,
        );
      }
    } catch (error) {
      console.warn("⚠️ Failed to cleanup credits from IndexedDB:", error);
    }

    this.th.initTheme();

    // Load theme from IndexedDB
    this.theme = await Settings.get<string>("theme");
  }
}
